import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const debtsRouter = {
    path: '/debtors',
    component: Layout,
    name: 'debts',
    redirect: '/debtors/index',
    children: [
        {
          path: '/debtors/index',
          component: () => import('@/views/debtors/index'),
          name: 'debtors.index',
          meta: { title: i18n.t('message.debtors') }
        },
    ]
}

export default debtsRouter